var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMomentumReversalsBottoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.096 28.008a1.25 1.25 0 001.715-.05L34.499 15.27v8.237a1.25 1.25 0 002.501 0V12.25C37 11.56 36.44 11 35.75 11H24.492a1.25 1.25 0 100 2.501h8.237L20.876 25.355 5.082 11.315a1.25 1.25 0 00-1.662 1.87l16.676 14.823z"
  })));
}
export default SvgMomentumReversalsBottoming;